import React, { FC, SyntheticEvent, useState } from 'react';
import {
  OnSubmitFunction,
  PaymentErrorProps,
  PaymentErrorType,
  PaymentMethodSource,
  PaymentMethodType,
} from 'api/data/payment/types';
import useSessionPreferences from 'hooks/useSessionPreferences';
import { Response } from '~/api/data/response/types';
import PaymentError from '../Error/PaymentError';
import './style.scss';

interface TerminalPaymentProps {
  onSubmit: OnSubmitFunction;
  pageId?: string;
  response: Response;
  paymentError?: PaymentErrorProps;
  setLoading: (loading: boolean) => void;
  loading: boolean;
}

const TerminalPayment: FC<TerminalPaymentProps> = ({
  onSubmit,
  pageId,
  response,
  paymentError,
  setLoading,
  loading,
}) => {
  const { acceptInPersonPayments } = useSessionPreferences();
  const [errorMessage, setErrorMessage] = useState<string>();

  const handleSubmit = async (event: SyntheticEvent) => {
    event.preventDefault();
    setLoading(true);
    setErrorMessage('');

    try {
      await processTerminalPayment();
    } catch (error) {
      setErrorMessage((error as PaymentErrorType).message);
    }

    setLoading(false);
  };

  const processTerminalPayment = async () => {
    await onSubmit({
      response,
      paymentMethodSource: PaymentMethodSource.PAYMENT_TERMINAL,
      paymentMethodType: PaymentMethodType.CARD,
      sessionKey: `${response.id}-payment-terminal`,
    });
  };

  const isSubmitDisabled = loading || !acceptInPersonPayments || (!!pageId && response.order.totalCents === 0);

  return (
    <div className="terminal-payment-container">
      {!loading && errorMessage && <PaymentError title={paymentError?.title} errorMessage={errorMessage} />}
      <form onSubmit={event => void handleSubmit(event)} className="payment-method" aria-label="payment terminal form">
        <button type="submit" disabled={isSubmitDisabled}>
          {loading ? 'Processing...' : 'Submit'}
        </button>
      </form>
    </div>
  );
};

export default TerminalPayment;
